<template>
  <div>
    <div class="content">
      <!-- <div class="item">
        <span class="title">二维码编号</span>
        <el-input v-model="parameter.code_no" placeholder="请输入内容" />
      </div> -->
      <div class="item">
        <span class="title">手机编号</span>
        <!-- <el-input v-model="parameter.phone_vx_account" placeholder="请输入内容" /> -->
        <el-autocomplete
          v-model="parameter.phone_vx_account.phone_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          @select="handleSelect"
        />
      </div>
      <div v-if="check.status" class="item">
        <span class="title">状态</span>
        <el-select v-model="parameter.status" placeholder="请选择">
          <el-option
            v-for="item in status_s"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="title">二维码类型</span>
        <el-select v-model="parameter.source_type" placeholder="请选择" @change="qrcodechanger">
          <el-option
            v-for="item in qRCodeType"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div v-if="parameter.source_type == 1" class="item">
        <span class="title">公众号名称</span>
        <el-autocomplete
          v-model="parameter.content.account_name"
          :fetch-suggestions="queryContent"
          placeholder="请输入微信号"
          @select="handleContent"
        />
      </div>

      <div v-if="parameter.source_type == 2" class="item">
        <span class="title">公众号名称</span>
        <el-autocomplete
          v-model="parameter.content.account_name"
          :fetch-suggestions="queryContent"
          placeholder="请输入公众号内容"
          @select="handleContent"
        />
      </div>
      <div class="item">
        <span class="title">推送类型</span>
        <el-select v-model="parameter.content_type" placeholder="请选择">
          <el-option
            v-for="item in appType"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>

      <div class="item">
        <span class="title">上传</span>
        <el-upload
          class="avatar-uploader"
          action="https://upload-z2.qiniup.com/"
          :show-file-list="false"
          :data="uploadData"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          multiple
          drag
        >
          <img v-if="parameter.content.src" :src="parameter.content.src" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon" />
        </el-upload>
        <!-- <div v-loading="uploading" class="pictureContent">
          <div v-if="parameter.content.src" class="pictureContent_item">
            <img class="pictureContent_item_img" :src="parameter.content.src">

            <div class="meng">
              <i class="el-icon-delete-solid" style="color: #fff;font-size: 23px;" @click="deleteImg()" />
            </div>
          </div>
          <div v-if="!parameter.content.src" class="exhibition" @click="myUpload">
            <input ref="file" style="display: none;" type="file" accept="image/*" @change="uploadPictures">
          </div>
        </div> -->
      </div>
    </div>
    <div style="margin-top: 20px; text-align: end;">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
import { scanCodeMobilePhoneList } from '@/api/mobilePhoneScanningCode' // 扫码手机列表
import { accountloginlist } from '@/api/sourceMaterial' // 公众号扫码列表
import { newMaterial } from '@/api/sourceMaterial.js' // 新增素材
import getNowDate from '@/utils/mixins/convertToHump.js'
export default {
  mixins: [getNowDate],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    check: {
      default() {
        return {
          phone_name: ''

        }
      }
    }
  },
  data() {
    return {
      parameter: {
        source_type: this.check.source_type,
        content_type: this.check.content_type,
        //  content: this.check.content ? { ...this.check.content, src: '' } : { account_name: '', src: '' },
        content: this.check.content ? { ...this.check.content, src: this.check.phone_name !== '' ? this.check.content.src : '' } : { account_name: '', app_id: '', src: this.check.phone_name !== '' ? this.check.content.src : '' },
        phone_vx_account: { ...this.check },
        status: this.check.status,
        app_id_text: this.check.app_id_text
      },
      uploading: false,
      token: null,
      qRCodeType: [{ id: 1, value: '登录' }, { id: 2, value: '授权' }, { id: 3, value: '群发' }, { id: 4, value: '其他' }],
      appType: [{ id: 1, value: '微信扫码' }],
      status_s: [{ id: 1, value: ' 待发送客户端处理' }, { id: 2, value: '已经发送' }, { id: 3, value: '已经处理(成功)' }, { id: 4, value: '处理失败' }, { id: 9, value: ' 删除' }],
      uploadData: {
        token: null,
        key: '',
        fname: ''
      }
    }
  },
  created() {
    window.aa = this
    this.getQiniuToken()
    this.account_name = this.check.content && this.check.content.account_name
    this.check.equipment_code && this.search(this.check.equipment_code)
    console.log('====', this.check)
  },
  methods: {

    // 上传图片到七牛
    async uploadPictures(e) {
      const fileIfon = e.target.files[0]

      /* const that = this
       var reader = new FileReader()
      reader.readAsDataURL(fileIfon) // readAsDataURL方法可以将上传的图片格式转为base64,然后在存入到图片路径,
      reader.onload = function() {
        var image = reader.result // image即base64格式，后面调用后端请求传入image
        that.parameter.content[that.parameter.content_type].push({ src: `${image}`, type: that.parameter.content_type, account_name: that.account_name })
        console.log('image', image)
      } */
      this.uploading = true

      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          this.uploading = false
          // https://ziyuan.jingxuansz.com
          // https://resource.jingxuanhz.com
          this.parameter.content = { ...this.parameter.content, src: `https://ziyuan.jingxuansz.com/${data.key}`, type: this.parameter.content_type }
        }

      })
    },

    // 搜索手机编号
    async querySearchAsync(value, cb) {
      const data = await scanCodeMobilePhoneList({ phone_name: value, page: 1, page_size: 100 })
      cb(data.data.list.map((item) => { return { ...item, value: item.phone_name, address: item.phone_vx_account } }))
    },

    // 搜索手机号对应的公众号
    async queryContent(value, cb) {
      const data = await accountloginlist({ phone_vx_account: this.parameter.phone_vx_account.phone_vx_account, page: 1, page_size: 100 })
      cb(data.data.list.map((item) => { return { ...item, value: item.app_id_text } }))
      //  console.log('++++++',value);
    },

    // 手机编号选中时触发
    handleSelect(item) {
      this.parameter.phone_vx_account = item
      // this.parameter.content.app_id = item.app_id
      // console.log('++++++',item);
    },
    // 公众号选中时触发
    handleContent(item) {
      // this.parameter.app_id_text = item
      this.parameter.content.app_id = item.app_id
    },

    // 搜索特定的号
    async search(value) {
      const data = await scanCodeMobilePhoneList({ phone_name: value, page: 1, page_size: 100 })
      if (data.data.list.length) {
        this.parameter.phone_vx_account = { ...data.data.list[0], phone_name: data.data.list[0].phone_name }
      }
    },

    // 点击上传图片
    myUpload() {
      if (!this.parameter.content_type || this.uploading) {
        this.$message({
          message: !this.parameter.content_type ? '请选择推送类型' : '有图片正在上传中',
          type: 'warning'
        })
        return
      }
      this.$refs.file.click()
    },

    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
      this.uploadData.token = data.data.upToken
    },

    // 删除图片
    deleteImg(index) {
      this.parameter.content.src = null
      this.uploading = false
    },

    determine() {
      const obj = {
        ...this.parameter,
        phone_vx_account: this.parameter.phone_vx_account.phone_vx_account,
        equipment_code: this.parameter.phone_vx_account && this.parameter.phone_vx_account.phone_name
      }
      Object.keys(this.check).length <= 1 && delete obj.status
      this.$emit('determine', obj)
    },
    qrcodechanger(val) {
      if (val !== 2) {
        this.parameter.content.account_name = ''
      }
    },
    accounchage(val) {
      this.parameter.content.account_name = val
    },

    async handleAvatarSuccess(res, file) {
      // 原来写法
      // https://resource.jingxuanhz.com
      // https://ziyuan.jingxuansz.com
      // this.parameter.content.src = `https://ziyuan.jingxuansz.com/${res.key}`

      // 新的写法
      newMaterial({
        type: 1,
        size: file.size,
        key: res.key
      }).then(response => {
        console.log('response', response)
        this.parameter.content.src = response.data.path
        // this.temporary = response.data.path
        // this.keyid = response.data.sourceMaterialId
        this.$message({
          message: '上传成功',
          type: 'success'
        })
      })
    },

    beforeAvatarUpload(file) {
      this.uploadData.fname = file.name
      const ftype = file.name.substr(file.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      // this.uploadData.key = `scanningCode/${Math.random().toString(36).slice(-6) + '--' + file.name}`
      this.uploadData.key = `scanningCode/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`
    }
  }
}
</script>

<style scoped lang="scss">
/* .content{

} */

.item{
    margin-bottom: 12px;
    display: flex;
}

.title{
    display: inline-block;
    width: 100px;
}

.el-input{
  width: 200px;
}

.exhibition{
    width: 100px;
    height: 100px;
    border-style: dotted;
    border-width: 1px;
    position: relative;
    cursor: pointer;
}

.exhibition::after{
   content: '';
    position: absolute;
    width: 50%;
    height: 1px;
    background-color: black;
    top: 50%;
    transform: translate(50%, 50%);
}

.exhibition::before{
    content: '';
    position: absolute;
    width: 1px;
    height: 50%;
    background-color: black;
    left: 50%;
    transform: translate(50%, 50%);
}

.exhibition:hover{
  border-color: #509cda;
}

.exhibition:hover::after{
   background-color:#509cda;
}

.exhibition:hover::before{
   background-color:#509cda;
}

.pictureContent{
    display: flex;
    flex-wrap: wrap;
}

.pictureContent_item{
    margin-right: 10px;
    cursor: pointer;
    position: relative;
}

.pictureContent_item_img{
    width: 100px;
    height: 100px;
}

.pictureContent_item:hover .meng{
     display: flex;
     align-items: center;
     justify-content: center;
     position: absolute;
     width: 100%;
     height: 100%;
     background-color: rgba(200, 200, 200, 0.7);
     top: 0px;
     left: 0px;
}

.meng{
  display: none;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

 .el-upload-dragger{
    width: 180px;
  }
  @media (max-width: 768px){
    .el-autocomplete{
      width:100%
    }
    .title{
      font-size:3vw;
    }
  }
</style>
